import { render, staticRenderFns } from "./BeforeLeavePage.vue?vue&type=template&id=72ff0eb3&"
import script from "./BeforeLeavePage.vue?vue&type=script&lang=js&"
export * from "./BeforeLeavePage.vue?vue&type=script&lang=js&"
import style0 from "./BeforeLeavePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports